<template>
<section class="Popin" v-show="store.state.user.isOnKeypoint && store.state.user.currentKp === id ">
  <!-- video element -->
  <section class="PopinVideo">
    <div class="Popin-guide" ref="guide">
      <div>
        <IconButton rounded class="CloseButton" @click="onClose" ref="btn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.47 169.48"><path fill="white" d="M159.47,169.48a10,10,0,0,1-7.07-2.93L2.93,17.07A10,10,0,0,1,17.07,2.93L166.54,152.41a10,10,0,0,1-7.07,17.07Z"/><path fill="white" d="M10,169.48a10,10,0,0,1-7.07-17.07L152.4,2.93a10,10,0,0,1,14.14,14.14L17.07,166.55A10,10,0,0,1,10,169.48Z"/></svg>
        </IconButton>
      </div>
    </div>
    <div ref="test" class="PopinVideo-wrapper">
      <VimeoPlayer :videoUrl="video" ref="vimeo"/>
    </div>
  </section>
</section>
</template>

<script>
import VimeoPlayer from '@/components/VimeoPlayer'
import IconButton from '@/components/IconButton'
import emitter from '@/emitter'

export default {
  props: {
    id: String,
    video: String
  },
  components: {
    VimeoPlayer,
    IconButton
  },
  data() {
    return {
      isOpen: false
    }
  },
 
  inject: ['store'],
  watch: {
    store: {
      handler: function (newValue) {
        if (this.id === newValue.state.user.currentKp && newValue.state.user.isOnKeypoint) {
          this.onOpen()
        }
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.$nextTick(() => {
      this.onResize();
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      if (window.innerHeight > window.innerWidth) {
        this.$refs.guide.style.width = '84vw'
      } else {
        this.$refs.guide.style.width = '107vh'
      }
      if (Math.abs(window.innerHeight - window.innerWidth) < 200) {
        this.$refs.guide.style.width = '84vw'
      }
    },
    onOpen() {
      // this.$refs.vimeo.setCurrentTime(0)
      this.$refs.vimeo.play()
    },
    onClose() {
      this.$refs.vimeo.pause()
      this.store.closekp()
      emitter.emit('HELLO')
    }
  },
}
</script>

<style lang="stylus" scoped>
.Popin
  position absolute
  z-index 1000
  width 100%
  height 100vh
  top 0
  background-color rgba(6, 41, 92, 0.2) //06295c
  padding 5%
  display flex
  justify-content center
  align-items center
  // TODO: responsive closebutton position to corner
  .Popin-guide
    position absolute
    z-index 8
    pointer-events none
    // opacity 0.4
    // background red
    width 107vh
    max-width 1100px
    top 50%
    left 50%
    transform translate(-50%, -50%)

    > div
      width 100%
      height 0
      padding-top 54.8%
      position relative

  .PopinVideo
    width 84vw
    margin auto
    &-wrapper
      position relative
      z-index 2

    >>> .VimeoPlayer
      > div
        height 84vw
        iframe
          height 100%
          width 100%

  .CloseButton
    position absolute
    right -6vw
    top -80px
    z-index 10
    pointer-events all

@media (orientation: portrait)
  .Popin 
    .Popin-guide
      width 84vw

@media (min-aspect-ratio: 4/5)
  .Popin 
    .Popin-guide
      width 107vh

</style>
